import { styled } from '@mui/material';

export const FileListPreviewStyles = styled('div')`
  display: grid;
  gap: 8px;
  margin: 10px 0;
`;
